export const sortById = (a, b) => {
  if (a.id < b.id) return -1;
  if (a.id > b.id) return 1;
  return 0;
};

export const mapRecurse = (fn, arr, recurseField = 'children') => {
  const mappedArr = [];

  for (let i = 0; i < arr.length; i++) {
    let mapped = fn(arr[i]);

    mapped[recurseField] = mapRecurse(fn, mapped[recurseField]);

    mappedArr.push(mapped);
  }

  return mappedArr;
};
